module.exports = __webpack_public_path__ + "img/peitu.c174495b.png";